// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__20_ah","containerItemsCenter":"Skeleton_containerItemsCenter__-LK7M"};